import axios from "axios";
import {CalendarData, CreateOrderData, OrderData} from "@/@types/api";

const configAuth = {
    auth: {
        // берем корневой домен, например vegas-hall.ru
        username: '', // todo через несколько дней убрать, когда кеш у клиентов удалится и всегда будет стартер передавать домен
        password: ''
    }
}

export function setAuthLogin(login: string) {
    configAuth.auth.username = login
}

const API_URL = 'https://api.vegas-ticket.ru/ocean/v3/'

export async function getCalendar(): Promise<CalendarData> {

    // 67 ледниковый обычный
    // 68 льгтный

    return new Promise((resolve, reject) => {
            axios.get(`${API_URL}/calendar?expositions=67,68`, configAuth)
                .then(result => {
                    resolve(result.data.data)
                })
                .catch(err => {
                    reject(err)
                })
        }
    )

}

export async function createOnlineOrder(data: CreateOrderData, sbp = false): Promise<OrderData> {

    return new Promise((resolve, reject) => {
            axios.post(`${API_URL}/locks`, {expo_tickets: data.tickets}, configAuth)
                .then(resultLock => {

                    axios.post(`${API_URL}/pay_orders`, {
                        lock_id: resultLock.data.data.lock_id,
                        user_information: {
                            name: data.name,
                            surname: '',
                            email: data.email,
                            phone: data.tel,
                            sms_agreement: false,
                            email_agreement: false
                        },
                        success_url: "https:ocean.vegas-ticket.ru/success",
                        failure_url: "https:ocean.vegas-ticket.ru/fail",

                    }, configAuth)
                        .then(resultOrder => {

                            resolve(resultOrder.data.data)

                        })
                        .catch(err => {
                            reject(err)
                        })


                })
                .catch(err => {
                    reject(err)
                })
        }
    )

}

// export function cancelOrder(orderId) {
//      //axios.get(`${ROOT_URL}order_cancel`, orderId)
// }


// export async function getPromocodeData(eventId: string, promocode: string, segments: number[]): Promise<SegmentsDiscounts> {
//     return new Promise((resolve, reject) => {
//             axios.get(`${API_URL}/promocode/${eventId}/${promocode}`,
//                 {
//                     ...configAuth, params: {segments: segments.join(',')}
//                 })
//                 .then(result => {
//                     // от 1с придет с кодом сегмента строковым
//                     <{ [segmentId: string]: number }>result.data.data
//
//                     const segmentDiscounts: SegmentsDiscounts = new Map
//                     for (const key in result.data.data)
//                         segmentDiscounts.set(Number(key), result.data.data[key])
//
//                     resolve(result.data.data)
//                 })
//                 .catch(err => {
//                     reject(err)
//                 })
//         }
//     )
//
// }
